import {
  Environment
} from '@vodacom/web-env';

import {
  Environments
} from '@vodacombusiness/web-vb-common';

const defaultConfig = {
  uiBase: '/cloud/business/log-in',
  assetBase: '/cloud/business/log-in/static'
};

Environment.init({
  Local: {
    ...Environments.Local,
    ...defaultConfig
  },
  Dev: {
    ...Environments.Dev,
    ...defaultConfig
  },
  QA: {
    ...Environments.QA,
    ...defaultConfig
  },
  Staging: {
    ...Environments.Staging,
    ...defaultConfig
  },
  Prod: {
    ...Environments.Prod,
    ...defaultConfig
  }
});
